module.exports = __webpack_public_path__ + "media/images/pc/visit_reserve/kv-question-2669242d3b28562f05da2f255cc934ea.png";